/* Mon activité — TC-03 (Bible §52 · locked #19).
   A participant sees their own attributed activity, the method behind it, the
   notice they acknowledged and the route to contest an attribution. No
   ranking of colleagues, ever — their detail is visible only to them and to
   managers, and the screen says so. */
import { Button, ErrorState, Tile, Tiles } from '@/ui'
import { useSelfView } from './api'
import { Chargement, Retour } from './parts'

export default function Moi() {
  const { data, isPending, isError, refetch } = useSelfView()

  if (isPending) return <Chargement />
  if (isError) return (
    <ErrorState what="Impossible de charger votre activité."
      action={<Button variant="primary" size="sm" onClick={() => refetch()}>Réessayer</Button>} />
  )

  return (
    <div style={{ display: 'grid', gap: 16, maxWidth: 420 }}>
      <Retour />
      <p className="t-eyebrow" style={{ margin: 0 }}>Mon activité · {data.name}</p>
      <h2 className="t-section" style={{ margin: 0 }}>Votre mois, {data.name}.</h2>

      <Tiles>
        <Tile label="Sessions éligibles" value={data.eligibleSessions} hint={data.window} />
        <Tile label="Cadeaux issus" value={data.giftsIssued} hint="de vos scans" />
      </Tiles>

      <p className="f-help" style={{ margin: 0 }}>
        Mesure&nbsp;: invitations proposées via <b>votre carte QR personnelle</b>.
      </p>
      <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
        <Button size="sm" variant="quiet">Comment c’est compté</Button>
        <Button size="sm" variant="quiet">Notice employé</Button>
        <Button size="sm" variant="quiet">Signaler une attribution</Button>
      </div>

      <p className="f-help" style={{ margin: 0 }}>
        Votre détail n’est visible que de vous et des responsables.
      </p>
    </div>
  )
}
